<template>
  <Dashboard grafana-path="/d/KnX4nkOOk/safety-dashboard" />
</template>

<script>
// @ is an alias to /src
import Dashboard from "@/components/Dashboard.vue";

export default {
  name: "SafetyPage",

  routing: {
    localizationKey: "menu.tab.safety",
    icon: "mdi-table-large",
    path: "/safety",
    hasAccess: (user) => user.isAdmin || user.isManager,
  },

  components: {
    Dashboard,
  },
};
</script>
